/* fc-pack-selector — drives the native Debutify variant picker from custom cards,
   and keeps the AOV stack (price block, savings banner, meter, urgency, sticky) in
   sync. Non-destructive: the native <variant-selects> is only hidden, never removed,
   so the theme's own price/media/ATC/quantity-break JS keeps working. */
(function () {
  'use strict';

  function moneyFmt(sampleText) {
    // derive currency prefix + decimal style from a Liquid-rendered `| money` string
    var m = String(sampleText || '').match(/^([^\d]*)/);
    var prefix = (m && m[1]) ? m[1] : '';
    var hasDecimals = /[.,]\d{2}\s*$/.test(String(sampleText || ''));
    return function (cents) {
      var whole = hasDecimals ? (cents / 100).toFixed(2) : String(Math.round(cents / 100));
      var parts = whole.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return prefix + parts.join('.');
    };
  }

  function initSelector(root) {
    if (root.__fcInit) return;
    root.__fcInit = true;

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-fc-card]'));
    if (!cards.length) return;

    // locate the native picker for this product/section
    var formId = root.getAttribute('data-form') || '';
    var sectionId = formId.replace(/^product-form-/, '');
    var scope =
      document.getElementById('variant-selects-' + sectionId) ||
      root.closest('.product, product-info, .product__info-wrapper, form[id="' + formId + '"]') ||
      document;
    var variantSelects = scope.closest ? (scope.closest('variant-selects') || scope) : scope;
    // widen scope to the whole product info so we can hide the native picker block
    var productScope = root.closest('product-info, .product, .product__info-container, .product__info-wrapper') || document.body;
    productScope.classList.add('fcpack-hide-native');

    var money = moneyFmt(cards[0].querySelector('.fcpack__now') ? cards[0].querySelector('.fcpack__now').textContent : '');

    var hero = root.querySelector('[data-fc-hero]');
    var heroAmt = root.querySelector('[data-fc-hero-amt]');
    var urgency = root.querySelector('[data-fc-urgency]');

    function setNativeVariant(card) {
      var val = card.getAttribute('data-option-value');
      if (variantSelects) {
        // button style → radio inputs
        var radios = variantSelects.querySelectorAll('input[type="radio"]');
        var matched = false;
        radios.forEach(function (r) {
          if (r.value === val) { if (!r.checked) { r.checked = true; } r.dispatchEvent(new Event('change', { bubbles: true })); matched = true; }
        });
        if (!matched) {
          // dropdown style → select
          var sel = variantSelects.querySelector('select');
          if (sel) {
            for (var i = 0; i < sel.options.length; i++) {
              if (sel.options[i].value === val) { sel.selectedIndex = i; break; }
            }
            sel.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
      // This theme's native variant->price/cart chain is inert on this template
      // (product-form has no submit button — COD form app), so drive it directly:
      setCartVariantId(card);
      updateThemePrice(card);
      updateUrl(card);
    }

    function setCartVariantId(card) {
      var id = card.getAttribute('data-variant-id');
      if (!id) return;
      document.querySelectorAll('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] input[name="id[]"]').forEach(function (inp) {
        inp.value = id; inp.disabled = false;
      });
    }

    function updateThemePrice(card) {
      var savePct = parseInt(card.getAttribute('data-save-pct'), 10) || 0;
      var cur = card.getAttribute('data-price-money');
      var cmp = card.getAttribute('data-compare-money');
      if (!cur) return;
      var scope = root.closest('product-info') || document;
      var priceEl = scope.querySelector('.price') || document.querySelector('.price');
      if (!priceEl) return;
      priceEl.querySelectorAll('.price__regular .price-item--regular').forEach(function (e) { e.textContent = ' ' + cur + ' '; });
      var sale = priceEl.querySelector('.price__sale .price-item--sale');
      if (sale) sale.textContent = ' ' + cur + ' ';
      var was = priceEl.querySelector('.price__sale s.price-item--regular, .price__sale .price-item--regular');
      if (savePct > 0) {
        priceEl.classList.add('price--on-sale');
        if (was) was.textContent = ' ' + cmp + ' ';
      } else {
        priceEl.classList.remove('price--on-sale');
      }
    }

    function updateUrl(card) {
      var id = card.getAttribute('data-variant-id');
      if (!id || !window.history || !window.history.replaceState) return;
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', id);
        window.history.replaceState({}, '', u.pathname + u.search);
      } catch (e) {}
    }

    function paint(card) {
      cards.forEach(function (c) {
        var on = c === card;
        c.classList.toggle('is-sel', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var price = parseInt(card.getAttribute('data-price'), 10) || 0;
      var would = parseInt(card.getAttribute('data-would'), 10) || 0;
      var savePct = parseInt(card.getAttribute('data-save-pct'), 10) || 0;
      var stock = parseInt(card.getAttribute('data-stock'), 10) || 0;
      var savings = Math.max(0, would - price);
      var savingsMoney = card.getAttribute('data-savings-money') || money(savings);

      if (hero && heroAmt) {
        if (savings > 0) { heroAmt.textContent = savingsMoney; hero.hidden = false; }
        else { hero.hidden = true; }
      }

      if (urgency) urgency.textContent = stock > 0 && stock <= 20 ? ('🔥 Hurry — only ' + stock + ' left in stock!') : '';

      // sticky mirror
      var sNow = document.querySelector('[data-fc-sticky-now]');
      var sSave = document.querySelector('[data-fc-sticky-save]');
      if (sNow) sNow.textContent = card.getAttribute('data-price-money') || money(price);
      if (sSave) sSave.textContent = savePct > 0 ? 'Save ' + savingsMoney : '';
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        e.preventDefault();
        if (card.hasAttribute('data-soldout')) return;
        setNativeVariant(card);
        paint(card);
      });
    });

    // keep cards in sync if variant changes elsewhere (theme JS / URL)
    function syncFromNative() {
      var current = null;
      var checked = variantSelects ? variantSelects.querySelector('input[type="radio"]:checked') : null;
      var sel = variantSelects ? variantSelects.querySelector('select') : null;
      var val = checked ? checked.value : (sel ? sel.value : null);
      if (val) {
        cards.forEach(function (c) { if (c.getAttribute('data-option-value') === val) current = c; });
      }
      if (current) paint(current);
    }
    if (variantSelects) {
      variantSelects.addEventListener('change', function () { setTimeout(syncFromNative, 0); });
    }

    // init: honor any already-selected native value, else first card
    var initial = cards.find(function (c) { return c.classList.contains('is-sel'); }) || cards[0];
    paint(initial);
    setNativeVariant(initial);

    // mobile sticky bar visibility
    var sticky = document.querySelector('[data-fc-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { sticky.hidden = en.isIntersecting; });
      }, { rootMargin: '0px 0px -40% 0px' });
      io.observe(root.querySelector('[data-fc-cards]') || root);
    }
  }

  function boot() {
    document.querySelectorAll('[data-fc-selector]').forEach(initSelector);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
